import { withFormik } from 'formik';
import Yup from 'yup';

import FormModal from 'buyside/components/presentation/Form/FormModal/formModal';

const AllocatorProfileFormModalContainer = withFormik({
  mapPropsToValues: ({ allocatorProfile }) => ({
    allocatorProfile,
    submitDetector: null
  }),
  validationSchema: ({ validationSchema }) => validationSchema || Yup.object(),
  handleSubmit: (
    { allocatorProfile },
    { props: { update, closeModal }, resetForm, setStatus, setSubmitting }
  ) => {
    update({ allocatorProfileId: allocatorProfile.id, allocatorProfile })
      .then(() => {
        closeModal();
        setTimeout(resetForm, 500);
      })
      .catch(() => {
        setStatus({ serverError: true });
        setSubmitting(false);
      });
  },
  enableReinitialize: true
})(FormModal);

export default AllocatorProfileFormModalContainer;
